class Anchoring {
    hash = window.location.hash

    constructor(el) {
        this.el = el;
        this.onMounted();
    }

    onMounted() {
        if (this.hash) {
            const target = this.hash.substring(1);
            const scrollElem = document.getElementById(target);
            const scrollTop = scrollElem.getBoundingClientRect().top + window.scrollY;                

            window.scrollTo({
                top: scrollTop,
                behavior: "smooth",
            });
            
            scrollElem.classList.add("opened");
        }
    }
}

window.addEventListener("load", () => {
    document
        .querySelectorAll(".js-anchoring")
        .forEach(el => new Anchoring(el));
});